import React from "react";
import { Route, Routes } from "react-router-dom"; // Remove BrowserRouter import here
import Home from "./pages/home/Home";
import News from "./pages/news/News";
import Events from "./pages/events/Events";
import Notification from "./pages/notifications/Notifications";
import NotificationDetails from "./pages/notifications/NotificationDetails";
import Users from "./pages/users/Users";
import UserDetails from "./pages/users/UserDetails"; // Create this page
import Clubs from "./pages/clubs/Clubs";
import MyClubs from "./pages/my-club/myClubs";
import ClubDetails from "./pages/clubs/ClubDetails"; // Create this page
import Profile from "./pages/profile/Profile";
import Messages from "./pages/messages/Messages";
import Account from "./pages/account/Account";
import SignIn from "./pages/auth/signin";
import SignUp from "./pages/auth/signup";
import Help from "./pages/help/Help";
import ForgotPassword from "./pages/auth/forgot-password";
import ResetPassword from "./pages/auth/reset-password";
import Layout from "./layout/layout";

function App() {
  return (
    <Routes>
      <Route path="signin" element={<SignIn />} /> {/* Use 'element' prop instead of 'component' */}
      <Route path="signup" element={<SignUp />} /> {/* Use 'element' prop instead of 'component' */}
      <Route path="reset-password" element={<ResetPassword />} /> {/* Use 'element' prop instead of 'component' */}
      <Route path="forgot-password" element={<ForgotPassword />} /> {/* Use 'element' prop instead of 'component' */}
      <Route path="help" element={<Help />} /> {/* Use 'element' prop instead of 'component' */}
      {/* ✅ Correctly Use Layout with Outlet */}
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="profile"  element={<Profile />} />
        <Route path="news"  element={<News />} />
        <Route path="events"  element={<Events />} />
        <Route path="messages"  element={<Messages />} />
        <Route path="notifications"  element={<Notification />} />
        <Route path="/notifications/:id" element={<NotificationDetails />} />
        <Route path="clubs"  element={<Clubs />} />
        <Route path="/clubs/:id" element={<ClubDetails />} /> {/* Dynamic ID */}
        <Route path="users"  element={<Users />} />
        <Route path="/users/:id"  element={<UserDetails />} />
        <Route path="my-clubs"  element={<MyClubs />} />
        <Route path="account"  element={<Account />} />
      </Route>
    </Routes>
  );
}

export default App;